const StatLink = ({ title, view, isSelectedView, Icon, handleToView }) => {
  return (
    <li className="mb-1">
      <a
        href="/"
        aria-current="page"
        className={'is-size-6 ' + (isSelectedView ? 'is-active ' : '')}
        onClick={(e) => handleToView(view, e)}
      >
        {title}
      </a>
    </li>
  )
}
export default StatLink
